import React from 'react';
import MasterCrud from './MasterCrud';

// Plant + customer/job → the dispatcher those tickets are hauled for. E.g. Martin Marietta loads to
// Reusable Organic Energy are IVY's work: paid at IVY's rates, settled on IVY's sheet, and listed as
// "Martin Marietta (IVY)" in the Plant filters.
export default function HauledForRules() {
  return (
    <MasterCrud
      title="Hauled For Rules"
      endpoint="/api/master/hauled-for-rules"
      columns={[
        { key: 'plantMatcher', label: 'Plant contains' },
        { key: 'customerMatcher', label: 'Customer contains' },
        { key: 'jobMatcher', label: 'Job / FS code contains' },
        { key: 'configId', label: 'Hauled for', lookup: 'configId' },
        { key: 'note', label: 'Note' },
        { key: 'updatedAt', label: 'Last updated' },
      ]}
      formFields={[
        { key: 'plantMatcher', label: 'Plant contains', required: true,
          helperText: 'Part of the plant name on the ticket, e.g. martin' },
        { key: 'customerMatcher', label: 'Customer contains',
          helperText: 'e.g. reusable organic energy — fill this, the job, or both' },
        { key: 'jobMatcher', label: 'Job / FS code contains',
          helperText: 'Matches the FS code or job code, e.g. ROE-' },
        { key: 'configId', label: 'Hauled for', type: 'select', required: true,
          optionsEndpoint: '/api/master/plant-payment-configs', optionValue: 'id', optionLabel: 'label',
          helperText: 'Whose pay and billing rules these tickets follow' },
        { key: 'note', label: 'Note' },
      ]}
    />
  );
}
